























































import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import {ApiMessage, DateTime, SiteInOutReportLine, TerminalLocation} from "../../modules/models";
import Api from "./Api";
import {numOrNull} from "../../modules/utils";
import {ForbiddenError} from "../../modules/PlayServerClient";
import UserRequired from "../UserRequired";
import BaseApi from "src/store/modules/base";

const left = "left";

class SioWithGuiHelpers extends SiteInOutReportLine {
    undoTxGuid: string | null = null;
    working: boolean = false;
}

@Component
export default class Onsite extends UserRequired {
    @Prop()
    locationId!: number;

    @Inject()
    api!: Api;
    @Inject()
    baseApi!: BaseApi;

    location: TerminalLocation | null = null;

    get locationDescription() {
        return this.location != null ? this.location.description : "";
    }

    loading = false;
    warning: string | null = null; // text set here is displayed in warning block at top of component

    headers = [
        {text: "Inn", value: "timeIn", align: left},
        {text: "Ut", value: "timeOut", align: left},
        {text: "Fornavn", value: "firstName", align: left},
        {text: "Etternavn", value: "lastName", align: left},
        {text: "Født", value: "birthDate", align: left},
        {text: "Firma", value: "companyName", align: left},
        {text: "Telefon/Kortnr", value: "cardNum", align: left}
    ];
    items: SioWithGuiHelpers[] = [];

    async loadTable() {
        this.loading = true;
        const reportlines = await this.api.fetchOnsiteLines(this.locationId);
        this.items = reportlines.map((rl: SiteInOutReportLine) => rl as SioWithGuiHelpers);
        this.loading = false;
    }

    numberOrNull(n: number): number | null {
        return numOrNull(n)
    }

    sioByGuid(guid: string): SioWithGuiHelpers | null {
        return this.items.find((sio: SioWithGuiHelpers) => sio.guid == guid) || null;
    }

    isRegisterOutAllowed(sioGuid: string): boolean {
      const user = this.baseApi.user;
      if(user != null) {
        const sio = this.sioByGuid(sioGuid);
        if(sio != null) {
          return user.isCompanyAdmin(sio.terminalLocation.companyOrgNum) ||
              user.isLocationAdmin(sio.terminalLocation.companyOrgNum, sio.terminalLocation.id);
        }
      }
      return false;
    }

    async registerOut(guid: string) {
        const sio = this.sioByGuid(guid);
        if(sio == null) {
            throw new Error(`sio with guid ${guid} not found`);
        }
        try {
            sio.working = true;
            const undoTxGuid = await this.api.sioAdminRegOutNow(guid);
            if(undoTxGuid instanceof ApiMessage) { // Something went wrong
                // Update view of data incase it is stale
                this.loadTable();
                if(undoTxGuid.num === 66) {
                    this.warning = "Utregistrering feilet. Kanskje bruker allerede er utregistrert. Prøv igjen hvis ikke.";
                } else {
                    this.emitError(new Error(undoTxGuid.msg));
                }
            } else {
                // set undo tx and time out on sio
                sio.undoTxGuid = undoTxGuid;
                sio.timeOut = DateTime.now();
                this.warning = null;
            }
        } catch (err) {
            if(err instanceof ForbiddenError) {
                this.warning = "Du må vere tildelt firma- eller anleggsadministratorrolle for å få registrere ut personer på anlegget.";
            } else {
                this.warning = null;
                this.emitError(err);
            }
        } finally {
            sio.working = false;
        }
    }

    async undoRegisterOut(guid: string, undoTxGuid: string) {
        const sio = this.sioByGuid(guid);
        if(sio != null && sio.undoTxGuid != null) {
            sio.working = true;
            await this.api.undoSioRegOut(sio.guid, sio.undoTxGuid);
            sio.timeOut = null;
            sio.undoTxGuid = null;
            sio.working = false;
        }
    }

    async loadLocation() {
        this.location = await this.api.fetchTerminalLocation(this.locationId);
    }

    @Watch("locationId", {immediate: true})
    onLocationIdChange() {
        if(this.locationId > 0) {
            this.loadLocation();
            this.loadTable();
        } else {
            this.location = null;
        }
    }

}
